module.exports = __webpack_public_path__ + "static/media/CV.b6bbd121.pdf";